<template>
  <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Holding Details</h5>
              <div class="float-right">
                <button type="button" class="close"  @click="$emit('close')">
                  <span aria-hidden="true">&times;</span>
                </button>
                <button v-if="isTraderFill" type="button" @click="updateHolding()" class="btn btn-primary">ASSIGN FILLED QTY</button>
              </div>
            </div>
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <div  v-if="isTraderFill"  style="float:left;margin: 7px;">Selected Offer Executed Qty : <span class="badge">{{executedQty}}</span></div>
              <br/>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <!-- <th scope="col"  class="sort text-center">CUSIP</th> -->
                    <th scope="col"  class="sort text-center">ACCOUNT</th>
                    <th scope="col"  class="sort text-center">QTY /COST </th>
                    <th scope="col"  class="sort text-center">BOUGHT</th>
                    <th scope="col"  class="sort text-center">HOLDING <br> QTY </th>
                    <th v-if="isTraderFill" scope="col" width="2"  class="sort text-center">ASSIGN <br>EXECUTED QTY </th>
                    <th scope="col"  class="sort text-center">OFFER <br> QTY - PRICE </th>
                    <th scope="col"  class="sort text-center"> OFFER <br> FILLED - REM </th>
                
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="customerOfferings.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr  v-for="offer in customerOfferings" :key="offer.inventoryId" >
                    <!-- <td class="text-center cusips">{{offer.cusipVal}}</td> -->
                    <td class="text-center text-primary">{{getAccountName(offer.accountMappingId)}}</td>
                    <td class="text-center text-success">{{offer.quantity}}/{{offer.cost | currency}}</td>
                    <td class="text-center">{{offer.boughtDate ? moment(offer.boughtDate).format("MM/DD/YYYY") : 'N/A' }}</td>
                    <td class="text-center">{{offer.assignedQuantity}}</td>
                    <td v-if="isTraderFill" class="text-center"><input type="text" v-model.number="offer.traderFillQty"  class="form-control" /></td>
                    <td class="text-center">{{offer.offerInventoryQuantity || 0}} - {{offer.offerInventoryPrice | currency}}</td>
                    <td class="text-center">{{offer.offerInventoryFilledQuantity ? offer.offerInventoryFilledQuantity : 'N/A' }} - {{offer.offerInventoryQuantity - offer.offerInventoryFilledQuantity || 'N/A' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
  </div>
</template>

    <script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'offeringCustomersmodal',
        components :{
            
        },
        props: ['offerData','isTraderFill','executedQty'],
        data() {
            return {
                loading : false,
                errors: [],
                customerOfferings : [],
                totalRecords : null,
                accountList : [],
                currentOffer: null
            };
        },
        methods: {  
          updateHolding(){
            var updateData = {};
            updateData.offeringId = this.currentOffer.id;
            updateData.inventoryFillQuantityUpdateDto = [];
            var invTotalQty = 0;
            this.customerOfferings.forEach(element => {
              let inv = {};
                  inv.inventoryId = element.inventoryId;
                  inv.filledQuantity = element.traderFillQty;
                  invTotalQty += element.traderFillQty;
              updateData.inventoryFillQuantityUpdateDto.push(inv)    
              
            });
            if(this.executedQty != invTotalQty){
              this.$alert("Total assigned holding qty not equal to offer executed qty ","","error");
              return false;
            }
            //console.log(updateData,invTotalQty);
            var message = "Please confirm that all assigned holding quantities are correct";
            this.$confirm(message).then(() => {
              const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
              };
              this.loading = true;
              this.$http
              .put(config.baseUrlBidSide + "/inventory/update-filled-quantity", updateData, auth)
              .then(() => {
                  this.loading = false;  
                  this.$emit('close');                             
              })
              .catch(() => {
                  this.loading = false;              
              });
            });
            
          
          },
          getCustomerOfferings(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/"+this.offerData.id,
                auth
            )
            .then(result => {
              this.currentOffer = result.data;
              this.customerOfferings = result.data.inventoryList;
              this.loading = false;
            })
          },
          getAllAccountList(){
            this.loading = true;
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken() }
              };
              this.$http
              .get(
              config.baseUrlBidSide +
                  "/inventory/account-map-list",
                  auth
              )
              .then(result => {
                this.accountList = result.data;
                this.getCustomerOfferings();

              })
          },
          getAccountName(accountMappingId){
            let inv  = this.accountList.find(o => o.accountMappingId === accountMappingId);
            if(inv){
                return inv.customerName +'-'+inv.account 
            }
          } 
        },
        mounted(){
          this.getAllAccountList()
        }
    };
    </script>